import React from 'react';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Card, Grid, Stack, Typography } from '@mui/material';
import Iconify from '../../../components/Iconify';

const PromotionCard = ({ promotion, onDelete, onEdit, onEnable, onDisable }) => {
  const navigate = useNavigate();
  const {
    _id,
    logo,
    title,
    author,
    slug,
    status,
    fromDateTime,
    toDateTime,
    createdAt,
    isHotPromotion,
    showBeforePublic,
    isLink,
  } = promotion;

  const currentDate = new Date();
  const endDateTime = new Date(toDateTime);
  const startDateTime = new Date(fromDateTime);

  const handleViewClick = () => {
    navigate(`/promotion/view/${slug}`);
  };

  return (
    <Card sx={{ mt: '8px' }}>
      <Grid container>
        <Grid item sm={5}>
          <img
            alt="logo"
            style={{ width: '100%', height: '250px', objectFit: 'cover' }}
            src={`${process.env.REACT_APP_IMAGE}${logo}`}
          />
        </Grid>
        <Grid item sm={7} p={3}>
          <Stack direction={'column'}>
            <Typography variant="h5" color="#A7202C">
              {title}
            </Typography>
            <Stack direction="row" sx={{ mt: 1 }} justifyContent="space-between">
              <Typography variant="subtitle2">Thời gian: </Typography>
              <Typography>
                {`${moment(fromDateTime).format('DD/MM/YYYY')} => ${moment(toDateTime).format('DD/MM/YYYY')}`}
              </Typography>
            </Stack>
            <Stack direction="row" sx={{ mt: 1 }} justifyContent="space-between">
              <Typography variant="subtitle2">Ngày tạo: </Typography>
              <Typography>{`${moment(createdAt).format('DD/MM/YYYY')}`}</Typography>
            </Stack>
            <Stack direction="row" sx={{ mt: 1 }} justifyContent="space-between">
              <Typography variant="subtitle2">Người đăng: </Typography>
              <Typography>{`${author.fullname} (${author.username})`}</Typography>
            </Stack>
            <Stack direction="row" sx={{ mt: 1 }} justifyContent="space-between">
              <Typography variant="subtitle2">Trạng thái: </Typography>
              <Stack direction="row" spacing={2}>
                {currentDate >= startDateTime && currentDate < endDateTime && status === 'Active' && (
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      background: '#6231d312',
                      color: '#2c91f1',
                      p: '2px',
                      borderRadius: '3px',
                    }}
                  >
                    <Iconify icon={'akar-icons:check-box'} sx={{ width: 16, height: 16, mr: 0.5 }} />
                    <Typography fontWeight={'bold'} variant="caption">
                      Đang diễn ra
                    </Typography>
                  </Box>
                )}
                {currentDate > endDateTime && (
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      background: '#ff006912',
                      color: '#f12c2c',
                      p: '2px',
                      borderRadius: '3px',
                    }}
                  >
                    <Iconify icon={'akar-icons:check-box'} sx={{ width: 16, height: 16, mr: 0.5 }} />
                    <Typography fontWeight={'bold'} variant="caption">
                      Quá hạn
                    </Typography>
                  </Box>
                )}
                {isHotPromotion && (
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      background: '#ff006912',
                      color: '#f12cb0',
                      p: '2px',
                      borderRadius: '3px',
                    }}
                  >
                    <Iconify icon={'akar-icons:check-box'} sx={{ width: 16, height: 16, mr: 0.5 }} />
                    <Typography fontWeight={'bold'} variant="caption">
                      Khuyễn mãi HOT
                    </Typography>
                  </Box>
                )}
                {showBeforePublic && (
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      background: '#1f00ff1f',
                      color: '#6133f2',
                      p: '2px',
                      borderRadius: '3px',
                    }}
                  >
                    <Iconify icon={'akar-icons:check-box'} sx={{ width: 16, height: 16, mr: 0.5 }} />
                    <Typography fontWeight={'bold'} variant="caption">
                      Luôn hiển thị
                    </Typography>
                  </Box>
                )}
                {isLink && (
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      background: '#00c8ff1f',
                      color: '#3ab5ac',
                      p: '2px',
                      borderRadius: '3px',
                    }}
                  >
                    <Iconify icon={'akar-icons:check-box'} sx={{ width: 16, height: 16, mr: 0.5 }} />
                    <Typography fontWeight={'bold'} variant="caption">
                      Dùng link
                    </Typography>
                  </Box>
                )}

                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    background: status === 'Inactive' ? '#ff9a001c' : '#1aff0012',
                    color: status === 'Inactive' ? '#f39c12' : '#42f233',
                    p: '2px',
                    borderRadius: '3px',
                  }}
                >
                  <Iconify icon={'akar-icons:check-box'} sx={{ width: 16, height: 16, mr: 0.5 }} />
                  <Typography fontWeight={'bold'} variant="caption">
                    {status}
                  </Typography>
                </Box>
              </Stack>
            </Stack>

            <Stack sx={{ mt: 1 }} direction="row" justifyContent="space-between">
              <Typography color="#C89134" variant="subtitle2" sx={{ cursor: 'pointer' }} onClick={handleViewClick}>
                Xem chi tiết <Iconify icon={'bi:arrow-right'} />
              </Typography>
              <Stack direction="row" spacing={1}>
                <Button variant="outlined" color="error" onClick={() => onDelete(_id)}>
                  Xóa bài viết
                </Button>
                <Button variant="outlined" color="success" onClick={() => onEdit(slug)}>
                  Cập nhật
                </Button>
                {status === 'Inactive' ? (
                  <Button variant="outlined" onClick={() => onEnable(_id)}>
                    Kích hoạt
                  </Button>
                ) : (
                  <Button variant="outlined" color="warning" onClick={() => onDisable(_id)}>
                    Ngừng hoạt động
                  </Button>
                )}
              </Stack>
            </Stack>
          </Stack>
        </Grid>
      </Grid>
    </Card>
  );
};

export default React.memo(PromotionCard);
